import { render, staticRenderFns } from "./OsProfileIconPopover.vue?vue&type=template&id=62358584&scoped=true"
import script from "./OsProfileIconPopover.vue?vue&type=script&lang=ts"
export * from "./OsProfileIconPopover.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62358584",
  null
  
)

export default component.exports